import template from '../../templates/Home/daily.template';
import Component from '../../core/component';

export default class Daily extends Component {
  constructor(data) {
    super(template, data);
  }
}
